import { buildAssistantHeaders, buildAssistantUrl } from "./assistantApi";

export type AssistantSegmentsChangedPayload = {
  marketIds: number[];
  op: "create" | "update" | "delete" | "unknown";
  segmentId?: number | string | null;
};

const normalizeMarketIds = (marketIds: number[]) =>
  Array.from(new Set((marketIds || []).map((id) => Number(id)).filter(Number.isFinite))).sort(
    (a, b) => a - b
  );

export const notifyAssistantSegmentsChanged = async (
  payload: AssistantSegmentsChangedPayload
) => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  const normalizedPayload = {
    ...payload,
    marketIds: normalizeMarketIds(payload.marketIds),
  };

  const response = await fetch(buildAssistantUrl("segments/changed/"), {
    method: "POST",
    headers: buildAssistantHeaders(),
    credentials: "include",
    body: JSON.stringify(normalizedPayload),
  });

  if (!response.ok) {
    throw new Error(`segments/changed failed with status ${response.status}`);
  }

  return response.json();
};
